import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { GuardHelper } from './guard.helper';
import { MeService } from '../global-services/me.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: MeService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const firebaseUser = await GuardHelper.getCurrentUser();
    const targetPath = route.routeConfig?.path;

    //--If logged out
    if (!firebaseUser) {
      this.router.navigate(['/sign-in']);
      return false;
    }

    let me = this.userService.getLastMeEmitted();
    if (me === null) {
      me = await this.userService.refreshMe();
    }

    //--If email not verified yet
    if (firebaseUser.emailVerified === false && targetPath === 'sign-up/confirm-email') {
      return true;
    }

    if (firebaseUser.emailVerified === false) {
      this.router.navigate(['sign-up/confirm-email']);
      return false;
    }

    //--If user has no organisations yet
    const userOrgPermissions = me!.userOrgPermissions;
    const allThatHaveOrgs = userOrgPermissions.filter((org) => org.organisation !== undefined);

    if (allThatHaveOrgs.length === 0 && targetPath === 'sign-up/ob-create-org') {
      return true;
    }

    if (allThatHaveOrgs.length > 0 && targetPath === "sign-up/ob-create-org") {
      this.router.navigate(["home"]);
      return false;
    }

    if (allThatHaveOrgs.length === 0) {
      this.router.navigate(['sign-up/ob-create-org']);
      return false;
    }

    //--set the defualt home page if fully onboarded
    if (targetPath === 'home' && MeService.isSystemAdminUser(me!)) {
      this.router.navigate(['admin/orgs']);
      return false;
    }

    if (targetPath === 'home' && MeService.isOrgAdminUser(me!)) {
      const org = me?.currentOrganisationId;
      this.router.navigate([`orgs/${org}/patients/manage`]);
      return false;
    }

    return true;
  }
}
